import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageTab from "@/components/i-pageTab/i-pageTab";
import PageTable from "@/components/i-pageTable/i-pageTable";
import { 
  selectCmsShareholderGroupPage, 
  addShareholderGroup, 
  editShareholderGroup, 
  deleteShareholderGroup,
  editShareholderGroupAmount
} from "./servers";
import { Button, message, Modal, Space } from "antd";
import { setIcons } from "@/utils/common";
import dayjs from "dayjs";
import { useIncomeTypes } from "@/stores/incomeTypes";


const PartnershipManager = () => {
  const incomeTypes = useIncomeTypes();

  const navigate = useNavigate();
  const [pageData, setPageData] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [amountModalOpen, setAmountModalOpen] = useState(false);
  const [modalFormData, setModalFormData] = useState<any>({});
  const [amountFormData, setAmountFormData] = useState<any>({});

  const [formData, setFormData] = useState<any>({
    groupName: "",
    ypageNum: 1,
    ypageSize: 10,
  });

  const formTab = [
    {
      label: "组名",
      name: "groupName",
      type: "input",
    },
  ];

  const modalFormTab = [
    {
      label: "组名",
      name: "groupName",
      type: "input",
      rules: [{ required: true, message: "请输入组名" }],
    },
    {
      label: "备注",
      name: "remark",
      type: "textArea",
    },
  ];

  const amountModalFormTab = [
    // {
    //   label: "股东分组ID",
    //   name: "id",
    //   type: "text",
    //   params: {
    //     text: amountFormData.id,
    //   },
    // },
    // {
    //   label: "组名",
    //   name: "groupName",
    //   type: "text",
    //   params: {
    //     text: amountFormData.groupName,
    //   },
    // },
    {
      label: "数额方式",
      name: "accountTrend",
      type: "select",
      options: [
        { label: "赚取", value: "1" },
        { label: "消耗/扣减", value: "2" },
      ],
      rules: [{ required: true, message: "请选择类型" }],
    },
    {
      label: "添加类型",
      name: "accountType",
      type: "select",
      options: incomeTypes.accountTypes.map((item) => ({ ...item, value: String(item.value) })),
      rules: [{ required: true, message: "请选择账户类型" }],
    },
    {
      label: "数额",
      name: "amount",
      type: "input",
      rules: [
        { required: true, message: "请输入数额" },
        { pattern: /^[0-9]+\.?[0-9]*$/, message: "请输入有效的数字" }
      ],
    },
  ];

  const footer = [
    {
      title: "添加分组",
      icon: setIcons("PlusOutlined"),
      onClick: () => {
        setModalFormData({});
        setOpen(true);
      },
    },
  ];

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "组名",
      dataIndex: "groupName",
      key: "groupName",
      render: (text: string, rows: any) => (
        <a
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/operation/partnershipManager/userList/${rows.id}/${encodeURIComponent(text)}`);
          }}
        >
          {text}
        </a>
      ),
    },
    {
      title: "备注",
      dataIndex: "remark",
      key: "remark",
    },
    {
      title: "创建时间",
      dataIndex: "createTime",
      key: "createTime",
      render: (time: any) => {
        return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
      },
    },
    {
      title: "操作",
      dataIndex: "id",
      key: "id",
      fixed: "right",
      width: "180px",
      render: (val: string, rows: any) => (
        <Space>
          <Button
            size="small"
            icon={setIcons("EditOutlined")}
            type="text"
            onClick={(e) => {
              e.stopPropagation();
              setModalFormData(rows);
              setOpen(true);
            }}
          >
            修改
          </Button>
          <Button
            size="small"
            icon={setIcons("DollarOutlined")}
            type="text"
            onClick={(e) => {
              e.stopPropagation();
              setAmountFormData({ id: rows.id, groupName: rows.groupName });
              setAmountModalOpen(true);
            }}
          >
            添加金额
          </Button>
          <Button
            size="small"
            icon={setIcons("DeleteOutlined")}
            type="text"
            onClick={(e) => {
              e.stopPropagation();
              handleDelete(val);
            }}
          >
            删除
          </Button>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    getPageData();
  }, [formData]);

  const getPageData = async () => {
    setLoading(true);
    try {
      const data = await selectCmsShareholderGroupPage(formData);
      setPageData(data.rows || []);
      setTotal(data.total || 0);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const search = (val: any) => {
    setFormData({ ...formData, ...val, ypageNum: 1 });
  };

  const reset = () => {
    setFormData({
      groupName: "",
      ypageNum: 1,
      ypageSize: 10,
    });
  };

  const resetModal = () => {
    setModalFormData({});
    setOpen(false);
  };

  const confirmSubmit = async (val: any) => {
    try {
      if (modalFormData.id) {
        await editShareholderGroup({ ...val, id: modalFormData.id });
        message.success("修改成功");
      } else {
        await addShareholderGroup(val);
        message.success("新增成功");
      }
      resetModal();
      getPageData();
    } catch (error) {}
  };

  const resetAmountModal = () => {
    setAmountFormData({});
    setAmountModalOpen(false);
  };

  const confirmAmountSubmit = async (val: any) => {
    const accountType = incomeTypes.accountTypes.find((item) => String(item.value) === String(val.accountType));
    if (!accountType || accountType.disabled) {
      message.error("请选择已开启的资金类型");
      return;
    }
    try {
      await editShareholderGroupAmount({
        accountTrend: val.accountTrend,
        accountType: val.accountType,
        amount: Number(val.amount),
        id: amountFormData.id,
      });
      message.success("金额调整成功");
      resetAmountModal();
      getPageData();
    } catch (error) {}
  };

  const handleDelete = (id: string) => {
    Modal.confirm({
      title: "提示",
      content: "确定要删除该分组吗？",
      onOk: async () => {
        try {
          await deleteShareholderGroup(Number(id));
          message.success("删除成功");
          getPageData();
        } catch (error) {}
      },
    });
  };

  const pageChange = (current: number, pageSize: number) => {
    setFormData({
      ...formData,
      ypageNum: current,
      ypageSize: pageSize,
    });
  };

  return (
    <div>
      <Modal
        destroyOnClose
        open={open}
        title={modalFormData.id ? "修改分组" : "添加分组"}
        width="360px"
        footer={<></>}
        onCancel={resetModal}
      >
        <PageTab
          subFoot
          search={confirmSubmit}
          reset={resetModal}
          formTab={modalFormTab}
          initialValues={modalFormData}
        ></PageTab>
      </Modal>
      <Modal
        destroyOnClose
        open={amountModalOpen}
        title="金额调整"
        width="360px"
        footer={<></>}
        onCancel={resetAmountModal}
      >
        <PageTab
          subFoot
          search={confirmAmountSubmit}
          reset={resetAmountModal}
          formTab={amountModalFormTab}
          initialValues={amountFormData}
        ></PageTab>
      </Modal>
      <PageTab
        search={search}
        reset={reset}
        formTab={formTab}
        footer={footer}
      ></PageTab>
      <PageTable
        loading={loading}
        pageChange={pageChange}
        size="small"
        rowKey="id"
        columns={columns}
        data={pageData}
        pagination={{
          current: formData.ypageNum,
          pageSize: formData.ypageSize,
          total: total,
        }}
      ></PageTable>
    </div>
  );
};

export default PartnershipManager;

